import React from "react";
import {Routes_path} from "../../routerApp";
import {PermissionTypes} from "../../authentication/permissionsGroups";
import HomeMenuButton from "./HomeMenuButton";
import TableChartIcon from "@mui/icons-material/TableChart";
import Grid from "@mui/material/Grid";


const HomeMenu = () => {

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            // sx={{ flexGrow: 1, mb: 1 }}
            rowSpacing={2}
            columns={{xs: 1, sm: 2, md: 3, lg: 4}}
            columnSpacing={{xs: 1, sm: 2, md: 3}}
            sx={{my: 2}}
        >
            <Grid key={2} size={12}>
                <HomeMenuButton
                    nome="Home"
                    gruppiAutorizzati={[
                        PermissionTypes.ALL,
                        // PermissionTypes.PIANIFICATORI_LETTURA,
                    ]}
                    path={Routes_path.HOME}
                    Icon={TableChartIcon}
                />
            </Grid>
        </Grid>
    );
};

export default HomeMenu;
